import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Icon } from 'react-fa';

import styles from './PersonField.css';
import formStyles from '../form/Form.css';
import NaturalPersonField from './NaturalPersonField';
import LegalPersonField from './LegalPersonField';
import SelectField from '../form/SelectField';

class PersonField extends React.Component {
  onRemove = () => {
    this.props.onRemove(this.props.id);
  }

  render() {
    const { model, title, onRemove, isAuthor, kind } = this.props;

    return (
      <div>
        {title &&
          <div className={formStyles.title}>
            {onRemove &&
              <button
                type="button"
                className={formStyles.removeButton}
                onClick={this.onRemove}
              >
                <Icon name="trash" />
              </button>
            }
            {title}
          </div>
        }

        <SelectField
          model={`${model}.kind`}
          inputProps={{
            clearable: false,
            options: [
              {
                label: 'Personne physique',
                value: 'natural',
              },
              {
                label: 'Personne morale',
                value: 'legal',
              },
            ],
          }}
        />

        <div className={styles.personBadge}>
          {'Personne ' + (kind === 'natural' ? 'physique' : 'morale')}
        </div>

        {kind === 'natural' ?
          <NaturalPersonField isAuthor={isAuthor} model={model} /> :
          <LegalPersonField isAuthor={isAuthor} model={model} />
        }
      </div>
    );
  }
}

export default connect((state, props) => ({
  kind: get(state, props.model).kind,
}))(PersonField);



/** WEBPACK FOOTER **
 ** ./client/act/PersonField.js
 **/